const backgroundColor = {
    A: 'crimson',
    B: 'cornflowerblue',
    C: 'green',
    D: 'blueviolet',
    E: 'brown',
    F: 'chocolate',
    G: 'darkblue',
    H: 'darkmagenta',
    I: 'darkolivegreen',
    J: 'darkslategrey',
    K: 'deeppink',
    L: 'firebrick',
    M: 'indianred',
    N: 'indigo',
    O: 'midnightblue',
    P: 'olivedrab',
    Q: 'orangered',
    R: 'rebeccapurple',
    S: 'seagreen',
    T: 'steelblue',
    U: 'tomato',
    V: 'teal',
    W: 'goldenrod',
    X: 'darksalmon',
    Y: 'dodgerblue',
    Z: 'darkkhaki',
};

const InitialAvatar = ({
    username,
    heightClass = 'h-10',
    widthClass = 'w-10',
    textLarge = false,
}) => {
    const removedEmail = username.split('@');
    if (!removedEmail || !removedEmail.length) return <></>;
    const cleanUsername = removedEmail[0].replace('.', '|').replace('-', '|').replace(' ', '|');
    const parts = cleanUsername.split('|');
    const color = backgroundColor[parts[0].substr(0, 1).toUpperCase()];
    return (
        <div
            className={`${heightClass} ${widthClass} flex items-center justify-center text-center rounded-full`}
            style={{
                backgroundColor: color,
                color: 'white',
                textAlign: 'center',
                fontSize:
                    parts.length > 2
                        ? textLarge
                            ? '1.6rem'
                            : '0.6rem'
                        : textLarge
                        ? '1.8rem'
                        : '0.8rem',
                padding: '5px',
            }}
        >
            {parts.map((part, index) => (
                <span key={index} className="inline-block text-xl">
                    {part.substr(0, 1).toUpperCase()}
                </span>
            ))}
        </div>
    );
};

export default InitialAvatar;
